<template>
  <a-modal
    title="支付宝付款"
    :width="600"
    :visible="visible"
    :pullLoading="pullLoading"
    @cancel="handleCancel"
  >
    <!-- <a-spin :spinning="pullLoading">
      <a-list itemLayout="horizontal" :dataSource="list">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <div class="product" :class="{active: index==currentIndex}" @click="handleSelectProduct(index)">
            <div class="bd">{{item.productDes}}</div>
            <div class="fd">{{item.productPrice/100 | currency('￥') }}元</div>
          </div>
        </a-list-item>
      </a-list>
    </a-spin>-->
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item label="购买商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['product_type',{rules: [{ required: true}]}]" placeholder="请选择">
            <a-select-option
              :value="item.id"
              v-for="(item,index) in list"
              :key="index"
            >{{item.productDes}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="购买数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            :min="1"
            v-decorator="['product_number', {initialValue:1,rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item
          label="实际支付"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >{{payment/100 | currency('￥') }}</a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="pullLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import ConductApi from '@/api/conduct'
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      pullLoading: false,
      confirmLoading: false,
      list: [],
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          setTimeout(() => {
            this.initPayment()
          }, 500)
        }
      }),
      payment: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    show(currentRobotId) {
      this.form.resetFields()
      this.payment = 0
      this.currentRobotId = currentRobotId
      this.visible = true
      this.getData()
    },
    getData() {
      this.pullLoading = true
      ConductApi.getProductList()
        .then(res => {
          if (res.code === 1) {
            this.list = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      const that = this
      const main_id = this.userInfo().id
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            product_type: values.product_type,
            product_number: values.product_number,
            main_id: main_id,
            sub_id: this.currentRobotId
          }
          ConductApi.getPayLink(params).then(link => {
            window.open(link)
            this.$confirm({
              title: '请在新窗口中完成支付',
              okText: '已完成支付',
              cancelText: '关闭',
              onOk() {
                that.visible = false
                that.$emit('ok')
              }
            })
          })
        }
      })
    },
    handleSelectProduct(index) {
      this.currentIndex = index
    },
    initPayment() {
      const product_number = this.form.getFieldValue('product_number')
      const product_type = this.form.getFieldValue('product_type')
      const product = this.list.find(item => {
        return item.id == product_type
      })
      if (!product) return false
      const product_price = product.productPrice
      this.payment = product_number * product_price
    }
  }
}
</script>
<style lang="less" scoped>
.product {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80px;
  align-items: center;
  box-shadow: 0px 0px 5px rgba(174, 174, 174, 0.5);
  color: #1890ff;
  border-radius: 5px;
  cursor: pointer;
  .bd {
    flex: 1;
    padding: 0 20px;
    font-size: 20px;
    font-weight: 600;
  }
  .fd {
    padding: 0 20px;
    font-size: 20px;
  }
}
.product.active {
  background: #1890ff;
  color: #ffffff;
}
</style>
